import React from "react";

function DateField({ id, label, ...rest }) {
  return (
    <div className="fieldContainer">
      <label>{label}</label>
      <input
        id={id}
        name={id}
        type="date"
        {...rest}
        className="p-2"
        style={{ color: rest?.disabled ? "gray" : "black" }}
      ></input>
    </div>
  );
}

export default DateField;
